import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteLayout from "@/components/SiteLayout";

export default function LegalLayout({ title, eyebrow, children }) {
    return (
        <SiteLayout>
            <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <Link to="/" className="inline-flex items-center gap-2 text-[#94a3b8] hover:text-[#f0c674] text-sm mb-10">
                    <ArrowLeft size={14} /> Zurück zur Startseite
                </Link>
                {eyebrow && <div className="label mb-4">{eyebrow}</div>}
                <h1 className="font-display text-4xl sm:text-5xl mb-10 leading-tight">{title}</h1>
                <div className="space-y-5 text-[#94a3b8] leading-relaxed text-[15px] [&_h2]:font-display [&_h2]:text-2xl [&_h2]:text-[#f8fafc] [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:text-[#f8fafc] [&_h3]:mt-6 [&_h3]:mb-2 [&_a]:text-[#f0c674] [&_a]:underline [&_strong]:text-[#f8fafc]">
                    {children}
                </div>
            </article>
        </SiteLayout>
    );
}
